import { Directive, Input } from "@angular/core";
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from "@angular/forms";

@Directive({
  selector:
    "[appMinimumAge][ngModel],[appMinimumAge][formControl],[appMinimumAge][formControlName]",
  providers: [
    { provide: NG_VALIDATORS, useExisting: MinimumAgeDirective, multi: true },
  ],
})
export class MinimumAgeDirective implements Validator {
  @Input("appMinimumAge") minAge: number;

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    if (!this.minAge) return null;
    return minimumAgeValidator(this.minAge)(control);
  }
}

export function minimumAgeValidator(minAge: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const birthDate = new Date(control.value);
    if (!control.value) return null; // se não tiver valor, não valida

    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // ajusta se ainda não fez aniversário no ano
    const isTooYoung =
      age < minAge ||
      (age === minAge && (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)));

    return isTooYoung ? { minimumAgeValidator: { valid: false } } : null;
  };
}
